let operator_routes = [
  {
    path: '/',
    component: () => import('Modules/Dashboard/resources/layout/DashboardLayout.vue'),
    children: [
      { path: 'operators', name: 'operators.list', component: () => import('./pages/Index.vue') },
      { path: 'operators/create', name: 'operators.create', component: () => import('./pages/Create.vue') },
      { path: 'operators/:id/edit', name: 'operators.edit', component: () => import('./pages/Edit.vue') }
    ]
  }
];

export default operator_routes;
